module.exports = __webpack_public_path__ + "static/media/policies.38748b7a.webp";